import React from 'react';
import { EllipsisIcon } from '@fiverr-private/visuals';
import { Popover, PopoverAnchor, PopoverChevron, PopoverContent } from '@fiverr-private/popover';
import { Stack } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import {
  ENTITY_TYPE,
  LazyReportContentModal,
  ReportingContextProvider,
  useReportingContext,
} from '@fiverr-private/content_reporting';
import { ActionCtaBase } from '../ActionCtaBase';
import { ReportGigItem } from './ReportGigItem';

const ShowMorePopover: React.FC = () => {
  const { fetchEligibility } = useReportingContext();

  const handleOpenChanged = (isOpen: boolean) => {
    if (isOpen) {
      fetchEligibility();
    }
  };

  return (
    <Popover position="bottom" onOpenChanged={handleOpenChanged}>
      <PopoverAnchor>
        <ActionCtaBase dataTestId="show_more_test_id">
          <EllipsisIcon />
        </ActionCtaBase>
      </PopoverAnchor>
      <PopoverContent disablePadding renderWhenClosed>
        <PopoverChevron />
        <Stack margin="2" direction="column">
          <ReportGigItem />
        </Stack>
      </PopoverContent>
    </Popover>
  );
};

export const ShowMoreCta: React.FC = () => {
  const {
    currentUser,
    general: { gigId, sellerId },
  } = useGigPageContext();

  const isRestricted = currentUser?.status === 'restricted';

  if (isRestricted) {
    return null;
  }

  return (
    <ReportingContextProvider
      entityId={`${gigId}`}
      entityType={ENTITY_TYPE.GIG}
      sellerId={`${sellerId}`}
      fetchOnMount={false}
    >
      <ShowMorePopover />
      <LazyReportContentModal />
    </ReportingContextProvider>
  );
};
